import type { ScenarioWithId } from "@/resources/scenario";
import type { Filter } from "@/utils/apiFilter";
import { apiClient } from "./apiClient";

class ScenarioService {
  async list(filter: Filter = {}): Promise<ScenarioWithId[]> {
    try {
      const response = await apiClient.get<ScenarioWithId[]>("/scenarios", {
        ...filter,
        limit: 1000,
      });
      if (response.status === "OK" && response.result) {
        return response.result;
      }
      return [];
    } catch (error) {
      console.error("Failed to list scenarios:", error);
      return [];
    }
  }

  async getById(scenarioId: string): Promise<ScenarioWithId | null> {
    try {
      const response = await apiClient.get<ScenarioWithId>(
        `/scenarios/${scenarioId}`,
      );
      if (response.status === "OK" && response.result) {
        return response.result;
      }
      return null;
    } catch (error) {
      console.error("Failed to get scenario by ID:", error);
      return null;
    }
  }
}

export const scenarioService = new ScenarioService();
